<template>
  <div class="success-container">
    <div class="success-content">
      <!-- 成功标题 -->
      <div class="success-header">
        <div class="success-icon">
          <i class="el-icon-success"></i>
        </div>
        <h1 class="success-title">注册成功!</h1>
        <p class="success-subtitle">请添加客服登录使用</p>
      </div>

      <!-- 客服联系方式 -->
      <div class="contact-section">
        <div class="contact-card wechat-card">
          <img src="../assets/wx.png" alt="微信" class="contact-icon" />
          <div class="contact-account">{{ wechatAccount }}</div>
          <el-button
            type="primary"
            class="copy-btn"
            @click="copyToClipboard(wechatAccount)"
          >
            复制账号
          </el-button>
        </div>
        <div class="contact-card qq-card">
          <img src="../assets/qq.png" alt="微信" class="contact-icon" />
          <div class="contact-account">QQ {{ qqAccount }}</div>
          <el-button type="primary" class="copy-btn" @click="copyToClipboard(qqAccount)">
            复制账号
          </el-button>
        </div>
      </div>

      <!-- 分隔线 -->
      <div class="divider"></div>

      <!-- 二维码区域 -->
      <div class="qrcode-section">
        <div class="qrcode-item">
          <div class="qrcode-wrapper">
            <img :src="wxErPng" alt="二维码1" class="qrcode-img" @click="showWxErPng = true" />
			<div v-if="showWxErPng" class="big-image-wrapper" @click="showWxErPng = false">
			  <img :src="wxErPng" class="big-image" />
			</div>
          </div>
          <el-button class="save-btn" @click="saveImage(wxErPng, 'wxEr.jpg')">
            保存图片
          </el-button>
        </div>
        <div class="qrcode-item">
          <div class="qrcode-wrapper">
            <img :src="qqErPng" alt="二维码2" class="qrcode-img" @click="showQqErPng = true"/>
			<div v-if="showQqErPng" class="big-image-wrapper" @click="showQqErPng = false">
			  <img :src="qqErPng" class="big-image" />	
			</div>
          </div>
          <el-button class="save-btn" @click="saveImage(qqErPng, 'qqEr.jpg')">
            保存图片
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wxErPng from "../assets/wxEr.jpg";
import qqErPng from "../assets/qqEr.jpg";
export default {
  name: "RegisterSuccess",
  data() {
    return {
      wechatAccount: "sw2019like",
      qqAccount: "2774235614",
      wxErPng: wxErPng,
      qqErPng: qqErPng,
	  showWxErPng: false,
	  showQqErPng: false
    };
  },
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success("复制成功！");
          })
          .catch(() => {
            this.$message.error("复制失败！");
          });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$message.success("复制成功！");
      }
    },
    saveImage(url, filename) {
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$message.success("保存成功！");
    },
  },
};
</script>

<style scoped>
.success-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #6aadfc, #d2e8fd);
  padding: 20px;
  background-image: url("../assets/rbk.png");
  background-size: 100% 100%;
  box-sizing: border-box;
}

.success-content {
  /* background: white; */
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 40px 30px;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.5s ease-in-out;
  background: linear-gradient(to bottom, #ffeef7, #f0f4ff, #e6f7ff);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-header {
  text-align: center;
  margin-bottom: 30px;
}

.success-icon {
  font-size: 64px;
  color: #67c23a;
  margin-bottom: 15px;
  animation: bounce 0.6s ease-in-out;
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

.success-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 10px 0;
  letter-spacing: 1px;
}

.success-subtitle {
  font-size: 16px;
  color: #999;
  margin: 0;
}

.contact-section {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 30px;
}

.contact-card {
  flex: 1;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
  border-radius: 12px;
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s, box-shadow 0.3s;
}

.contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.contact-icon-wrapper {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.contact-icon-wrapper.qq-icon-wrapper {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.contact-icon-wrapper.qq-icon-wrapper i {
  color: white;
  font-size: 32px;
}

.contact-icon {
  width: 60px;
  height: 60px;
  padding-bottom: 16px;
}

.contact-account {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 15px;
  word-break: break-all;
  text-align: center;
}

.copy-btn {
  width: 100%;
  background: linear-gradient(135deg, #6aadfc 0%, #4a8fe7 100%);
  border: none;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 20px;
  transition: all 0.3s;
}

.copy-btn:hover {
  background: linear-gradient(135deg, #5a9df0 0%, #3a7fd7 100%);
  box-shadow: 0 4px 12px rgba(74, 143, 231, 0.4);
}

.copy-btn:active {
  transform: scale(0.98);
}

.divider {
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #e0e0e0 50%, transparent 100%);
  margin-bottom: 30px;
}

.qrcode-section {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.qrcode-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-wrapper {
  width: 100%;
  background: #f5f5f5;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05);
}

.qrcode-img {
  width: 100%;
  max-width: 140px;
  height: auto;
  border-radius: 8px;
}

.save-btn {
  width: 100%;
  background: white;
  border: 2px solid #e74c3c;
  color: #e74c3c;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 20px;
  transition: all 0.3s;
}

.save-btn:hover {
  background: #e74c3c;
  color: white;
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
}

.save-btn:active {
  transform: scale(0.98);
}

.big-image-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .big-image {
    max-width: 80%;
    max-height: 80%;
  }
</style>
